export enum TransactionSubtypeEnum {
    Uknown = -1,
    RegisterCheckIn = 0,
    CashPickUp = 1,
    RegisterCheckOut = 2,
    CashAdvance = 3,
}

export function transactionSubtypeEnumLabel(val: TransactionSubtypeEnum): string {
    let res = "";
    switch (val) {
        case TransactionSubtypeEnum.RegisterCheckIn:
            res = "enum.transaction_subtypes.register_checkin";
            break;
        case TransactionSubtypeEnum.CashPickUp:
            res = "enum.transaction_subtypes.cash_pickup";
            break;
        case TransactionSubtypeEnum.RegisterCheckOut:
            res = "enum.transaction_subtypes.register_checkout";
            break;
        case TransactionSubtypeEnum.CashAdvance:
            res = "enum.transaction_subtypes.cash_advance";
            break;
        default:
            res = "common.unknown";
            break;
    }
    return res;
}
